// web/src/features/home/HomeCanvas.tsx
// The read-only Home canvas: every widget free-placed in one grid (grouping was
// removed).
import type { HomeLayout } from './types';
import { WidgetGridView } from './WidgetGridView';

export function HomeCanvas({ layout }: { layout: HomeLayout }) {
  return <WidgetGridView widgets={layout.widgets} />;
}
